
import { Component } from 'react';
import PropTypes from 'prop-types';

class LayerThreeDashboardComponent extends Component {
    constructor(props, channel) {
        super(props);
        this.state = {
            entityId: null,
            channel: channel || props.channel
        };
    }

    static getDerivedStateFromProps(props, state) {
        const entityId = parseInt(props.entityId || props.match.params.entityId, 10);
        if (entityId !== state.entityId) {
            return {
                ...state,
                entityId
            };
        }

        return null;
    }

    getCurrentEntityId() {
        return this.state.entityId;
    }

    getCurrentChannel() {
        return this.state.channel;
    }

    createPayload(entityId, channel) {
        return {
            transactionId: `entity-${entityId}-${channel}`,
            entityId,
            channel,
            tactic: channel
        };
    }

    componentDidMount() {
        this.makeRequestsForData();
    }

    makeRequestsForData() {
        throw new Error('Not Implemented');
    }

    componentDidUpdate(prevProps, prevState) {
        const isEntityChanged = prevState.entityId !== this.getCurrentEntityId();
        const isTimeRangeChanged = prevProps.selectedTimeRange !== this.props.selectedTimeRange;

        if (isTimeRangeChanged || isEntityChanged) {
            this.makeRequestsForData();
        }
    }
}

LayerThreeDashboardComponent.propTypes = {
    selectedTimeRange: PropTypes.shape({
        label: PropTypes.string,
        key: PropTypes.string
    }).isRequired,
    match: PropTypes.shape({
        params: PropTypes.shape({
            entityId: PropTypes.string.isRequired
        })
    })
};

export default LayerThreeDashboardComponent;

export class LayerTwoDashboardComponent extends LayerThreeDashboardComponent {
    createPayload(entityId, channel) {
        return {
            transactionId: `entity-${entityId}-layer-two-${channel}`,
            entityId,
            channel,
            tactic: channel
        };
    }
}

export class SocialObjectiveDashboardComponent extends LayerThreeDashboardComponent {
    constructor(props, objective) {
        super(props);
        this.state = {
            entityId: null,
            objective
        };
    }

    createPayload(entityId, objective) {
        return {
            transactionId: `entity-${entityId}-social-${objective}`,
            entityId,
            objective
        };
    }

    getCurrentObjective() {
        return this.state.objective;
    }
}

export class SiteDirectChannelDashboardComponent extends LayerThreeDashboardComponent {
    constructor(props, ioChannel) {
        super(props);
        this.state = {
            entityId: null,
            ioChannel
        };
    }

    createPayload(entityId, ioChannel) {
        return {
            transactionId: `entity-${entityId}-site-${ioChannel}`,
            entityId,
            ioChannel
        };
    }

    getCurrentIOChannel() {
        return this.state.ioChannel;
    }
}



// WEBPACK FOOTER //
// ./src/containers/dashboards/DashboardBaseComponent.js